var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 40,
    viewBox: "0 0 111 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tipngoc0ta)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.176 26.25H46.83v-4.437h4.317c1.828 0 2.847.93 2.847 2.28 0 1.258-1.02 2.156-2.818 2.156zM46.83 13.69h3.477c1.589 0 2.398.87 2.398 2.07 0 1.227-.81 2.127-2.398 2.127H46.83V13.69zm7.854 5.755c1.708-.869 2.577-2.338 2.577-4.167 0-2.76-1.701-5.115-5.477-5.51V6.283h-2.578v3.42h-1.221v-3.42h-2.578v3.42h-3.223v20.533h3.223v2.057h2.578v-2.057h1.22v2.057h2.579v-2.069c4.603-.126 6.856-2.594 6.856-5.862 0-2.4-1.38-4.138-3.956-4.917zm5.42 10.791h4.167V14.86h-4.167v15.377zm0-16.696h4.167V9.703h-4.167v3.837zm10.424-3.823h-4.166v14.059c0 3.447 1.829 5.275 5.905 5.275h2.039v-3.566h-1.74c-1.408 0-2.038-.54-2.038-1.919v-6.175h3.778v-3.716h-3.778V9.717zm12.167 15.977c-2.337 0-4.046-1.829-4.046-4.287s1.798-4.255 4.136-4.255 4.137 1.797 4.137 4.255-1.889 4.287-4.227 4.287zm.09-12.32c-4.706 0-8.243 3.567-8.243 8.033 0 4.498 3.507 8.004 8.243 8.004 4.736 0 8.273-3.537 8.273-8.004 0-4.496-3.537-8.033-8.273-8.033zm17.92 12.2c-2.338 0-4.197-1.858-4.197-4.136 0-2.309 1.799-4.137 4.197-4.137 2.278 0 4.046 1.828 4.046 4.137 0 2.278-1.768 4.136-4.046 4.136zm.36-12.05c-1.74 0-3.417.51-4.496 1.35v-1.2h-4.167v20.653h4.167v-6.445c1.079.84 2.757 1.38 4.496 1.38 4.196 0 7.764-3.479 7.764-7.914a7.779 7.779 0 0 0-7.764-7.824z",
    fill: "#54998D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.316 19.809c0 6.56 5.32 11.88 11.881 11.88 5.812 0 10.64-4.174 11.671-9.686.133-.712.21-1.444.21-2.194 0-4.608-2.627-8.594-6.46-10.565a11.807 11.807 0 0 0-5.42-1.317c-6.563 0-11.882 5.32-11.882 11.882zm12.284-8.87a8.74 8.74 0 0 1 2.355.445v1.953a7.04 7.04 0 0 1 3.533 3.774l-2.13.888a4.782 4.782 0 0 0-1.403-1.928 4.647 4.647 0 0 0-2.355-1.028c-.207-.028-.41-.063-.625-.063-.245 0-.48.036-.715.072a4.671 4.671 0 0 0-2.355 1.093c-.995.864-1.638 2.123-1.638 3.543s.643 2.679 1.638 3.543c.654.568 1.46.956 2.355 1.094.235.036.47.072.715.072.214 0 .418-.035.625-.063a4.673 4.673 0 0 0 2.355-1.028 4.797 4.797 0 0 0 1.298-1.68l2.131.912a7.052 7.052 0 0 1-3.429 3.5v2.206a8.816 8.816 0 0 1-2.355.442v-2.008a7.164 7.164 0 0 1-.625.032c-.24 0-.48-.013-.715-.036v1.989a8.814 8.814 0 0 1-2.355-.573v-2.095a7.013 7.013 0 0 1-3.95-6.307 7.013 7.013 0 0 1 3.95-6.306v-1.854a8.814 8.814 0 0 1 2.355-.573v1.748a6.792 6.792 0 0 1 1.34-.004v-1.76z",
    fill: "url(#3k99hkexmb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 0 1.227 9.58l5.427 3.117c2.392-3.875 6.657-6.469 11.545-6.469 2.234 0 4.337.549 6.196 1.506a13.64 13.64 0 0 1 5.14 4.639l4.848-2.81L17.82 0z",
    fill: "url(#vdltlg8t5c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.334 13.806c.905 1.814 1.446 3.836 1.446 6.002a13.486 13.486 0 0 1-1.62 6.386l4.982 2.863V11.02l-4.808 2.787z",
    fill: "url(#rn8d5tje8d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 29.204 5.603-3.248a13.5 13.5 0 0 1-1.485-6.147c0-2.028.468-3.938 1.265-5.665L.5 11.052v18.152z",
    fill: "url(#1t5a1maqme)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45 30.55 17.82 40l16.498-9.526-5.023-2.883c-2.453 3.498-6.498 5.798-11.097 5.798-4.697 0-8.815-2.4-11.253-6.025L1.45 30.55z",
    fill: "url(#fq3w86o5nf)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3k99hkexmb",
    x1: 3.491,
    y1: 5.106,
    x2: 28.608,
    y2: 30.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vdltlg8t5c",
    x1: 7.752,
    y1: 5.347,
    x2: 22.802,
    y2: 20.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rn8d5tje8d",
    x1: 30.973,
    y1: -3.386,
    x2: 45.1,
    y2: 10.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1t5a1maqme",
    x1: 2.453,
    y1: 12.876,
    x2: 16.829,
    y2: 27.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fq3w86o5nf",
    x1: -2.679,
    y1: 30.175,
    x2: 12.386,
    y2: 45.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A39C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tipngoc0ta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h111v40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic-logo.b4ce3b332189d7ecab58368eb221e25e.svg";
export { ForwardRef as ReactComponent };